<template>
    <div class="all">
        <el-tag v-for="item in personsD" :type="whichType(item)"  @click="current=item">{{item.name}}
            <el-badge :value="item.num"></el-badge>
        </el-tag>
    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            return {
                relation: null,
                persons: [],
                current:null
            }
        },
        mounted() {
            if (this.$store.state.relation.relation === null) {
                this.$store.dispatch('relation/getAll').then((rs) => {
                    this.relation = rs
                })
            } else {
                this.relation = this.$store.state.relation.relation
            }
        },
        watch: {
            relation: {
                handler(value) {
                    if (value) {
                        value.forEach((el) => {
                            this.persons.push(...el.persons)
                        })
                    }
                },
                immediate: true
            },
            current: {
                handler(value) {
                    if (value) {
                        let array=[]
                        this.relation.forEach((el)=>{
                            let fi=el.persons.filter((ex)=>{
                                return ex.name.indexOf(value.name)>-1
                            })
                            if(fi.length>0){
                                array.push(el.title)
                            }
                        })
                        console.log(array)

                    }
                },
                deep:true,
                immediate: true
            },
        },
        computed: {
            personsD() {
                //let sortD = this.persons.sort((a, b) => a['name'].toLowerCase().localeCompare(b['name'].toLowerCase()))
                const resultMap = {}
                this.persons.forEach((item) => {
                    if (resultMap[item.name]) {
                        resultMap[item.name]++
                    } else {
                        resultMap[item.name] = 1
                    }
                })

                const result = Object.keys(resultMap).map(name => ({
                    name: name,
                    num: resultMap[name]
                }))

                return result.sort((a, b) => b['num']-a['num']).filter((el)=>{
                    return el.num>1
                })
            }
        },
        methods: {
            whichType(it) {
                // if(it.gender=='女'){
                //     return 'danger'
                // }
                // if(it.gender=='物'){
                //     return 'warning'
                // }

            }

        }
    }
</script>
<style scoped>
    .all {
        display: flex;
        gap: 5px;
        flex-wrap: wrap;
    }


    @media (max-width: 768px) {


    }
</style>

